import SharedFolderApi from 'client/api/v2/SharedFolderApi';
import createModel from 'client/store/modules/models/createModel';

export const getDefaultItem = () => ({
  uuid: '',
  name: '',
  usersWithAccess: 0,
  itemsInFolder: 0,
  createdAt: '',
});

const idField = 'uuid';
const model = createModel(getDefaultItem, idField, SharedFolderApi);

export default {
  namespaced: true,
  state: {
    ...model.state,
  },

  actions: {
    ...model.actions,

    loadSharedFolder({ dispatch }, id) {
      dispatch('setItemField', { key: idField, value: id });
      return dispatch('fetchItem');
    },
  },

  getters: {
    ...model.getters,
  },

  mutations: {
    ...model.mutations,
  },
};
